<div class="pagetitle encabezado-pagina">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="d-flex align-items-center flex-wrap gap-2">
      @if (mostrarVolver) {
        <button class="btn btn-warning btn-sm" type="button" (click)="regresar()">
          <i class="bi bi-arrow-return-left" [pTooltip]="tooltipVolver" tooltipPosition="top"></i>
        </button>
      }
      <h6 class="mb-0">
        <i class="bi" [ngClass]="icono"></i>&nbsp;<b>{{ titulo }}</b>
      </h6>
      <ng-content select="[encabezado-resumen]"></ng-content>
    </div>
    <div class="d-flex align-items-center gap-1">
      <ng-content select="[encabezado-acciones]"></ng-content>
    </div>
  </div>
  <div class="encabezado-pagina__metadatos">
    <ng-content select="[encabezado-metadatos]"></ng-content>
  </div>
</div>
